import ToggleButton from 'vue-js-toggle-button';

export default {
  expose(Vue) {
    Vue.use(ToggleButton);
  },
};
